import { setObjectValue, Dep } from "../../../framework/Processes";
import { External } from "../../../framework/comp/Lambda/Constructors";
import { FunctionType } from "../../../framework/comp/Types";

export default {
	name: 'task_0_1',
	description: 'Заставка',
	title: 'Режим прохождения игры',
	minigameType: 'Intro',
	generateParams() {
		return {
            question: "Выберите сценарий прохождения игры",
			options: ["Случайные задачи", "Фиксированный порядок"],
			correct: [0]
        };
	},
	postprocess: Dep(External(function(state) {
		const { history } = state.objects;
		const playerChoice = history[history.length - 1].playerAns;
		return setObjectValue("mode", playerChoice);
	}, "Function", FunctionType("Object", "Process"))),

	isCompleted: () => true,
};